import React, { useState, useEffect } from 'react';
import Logo from '../assets/images/Vector.svg';
import IndusLogo from '../assets/images/Logo.svg';
import GlobalIcon from '../assets/images/Global.svg';
import Banner1 from '../assets/images/indusBanner1.png';
import Banner2 from '../assets/images/indusBanner2.png';
import Banner3 from '../assets/images/indusBanner3.png';
import Banner4 from '../assets/images/indusBanner4.png';
import QuoteDialog from './QuoteDialog';
import useScrollAnimation from '../hooks/useScrollAnimation';
import './Hero.css';

const Hero = () => {
  const [isLargeScreen, setIsLargeScreen] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isQuoteDialogOpen, setIsQuoteDialogOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  
  // Scroll animations
  const [headerRef, isHeaderVisible] = useScrollAnimation(0.3);
  const [contentRef, isContentVisible] = useScrollAnimation(0.4);
  const [furnitureRef, isFurnitureVisible] = useScrollAnimation(0.5);
  
  // Initial load state for hero elements
  const [isInitialLoad, setIsInitialLoad] = useState(false);
  
  useEffect(() => {
    // Hero elements load immediately
    const timer = setTimeout(() => {
      setIsInitialLoad(true);
    }, 200);
    
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth > 1200);
    };

    // Check on mount
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener('resize', checkScreenSize);

    // Cleanup event listener
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const handleGetQuote = () => {
    setIsQuoteDialogOpen(true);
  };

  const handleCloseQuoteDialog = () => {
    setIsQuoteDialogOpen(false);
  };

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    setSelectedImage(null);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleCloseDialog();
    }
  };

  // Banner images
  const bannerImages = [
    { src: Banner1, alt: "Industrial Furniture 1" },
    { src: Banner2, alt: "Industrial Furniture 2" },
    { src: Banner3, alt: "Industrial Furniture 3" },
    { src: Banner4, alt: "Industrial Furniture 4" }
  ];

  return (
    <section className="hero-section">
      {/* Header with Logo and CTA Button */}
      <header ref={headerRef} className={`hero-header ${isHeaderVisible || isInitialLoad ? 'visible' : ''}`}>
        <div className={`logo-container fade-in ${isInitialLoad ? 'visible' : ''}`}>
          <img 
            src={Logo} 
            alt="Indus Trade Logo" 
            className="logo-icon" 
          />
        </div>
        <button className={`cta-button button-bounce ${isInitialLoad ? 'visible' : ''}`} onClick={handleGetQuote}>
          GET A QUOTE
        </button>
      </header>

      {/* Hero Content */}
      <div ref={contentRef} className={`hero-content ${isContentVisible || isInitialLoad ? 'visible' : ''}`}>
        <img src={GlobalIcon} alt="Global Icon" className={`global-icon image-reveal ${isInitialLoad ? 'visible' : ''}`} />
      </div>

      {/* Furniture Products Section */}
      <div ref={furnitureRef} className={`furniture-section ${isFurnitureVisible || isInitialLoad ? 'visible' : ''}`}>
        <div className="furniture-container">
          {bannerImages.concat(bannerImages).map((image, index) => (
            <div 
              key={index} 
              className={`furniture-item fade-in ${isInitialLoad ? 'visible' : ''}`}
              onClick={() => handleImageClick(image)}
            >
              <img src={image.src} alt={image.alt} />
            </div>
          ))}
        </div>
      </div>

      {/* Image Dialog */}
      {isDialogOpen && selectedImage && (
        <div className="image-dialog-overlay" onClick={handleOverlayClick}>
          <div className="image-dialog">
            <div className="dialog-header">
              <h3>Product Preview</h3>
              <button 
                className="dialog-close-btn"
                onClick={handleCloseDialog}
              >
                ×
              </button>
            </div>
            <div className="dialog-content">
              <img 
                src={selectedImage.src} 
                alt={selectedImage.alt}
                className="dialog-image"
              />
            </div>
          </div>
        </div>
      )}

      {/* Quote Dialog */}
      <QuoteDialog 
        isOpen={isQuoteDialogOpen}
        onClose={handleCloseQuoteDialog}
        title="Get a Quote"
      />
    </section>
  );
};

export default Hero;
